import gql from 'graphql-tag'

export const RESET_PASSWORD_USER = gql`
  mutation notifyFlashExpress($input: ResetPasswordUserInput!) {
    resetPasswordUser(input: $input) {
      errors
    }
  }
`

export default {
  RESET_PASSWORD_USER
}
